import { Component } from '@angular/core';
import { FieldWrapper, FormlyFieldConfig } from '@ngx-formly/core';

@Component({
    selector: 'mutara-file-checklist',
    templateUrl: './file-checklist.component.html',
    styleUrls: ['./file-checklist.component.scss'],
    standalone: false
})
export class FileChecklistComponent extends FieldWrapper {

  get isUploaded() : boolean {
    return !!this.field.props?.getValue(this.field);
  }
  get isVisible() : boolean {
   // console.log('Visible %O Children %O', this.field.key, this.field.fieldGroup.filter( child => !child.hide)?.map( kid => kid.key));
     return this.field?.fieldGroup?.some( child => !child.hide) ?? false;
  }

  isValid(field: FormlyFieldConfig): boolean {
    if (!!field.key) {
      return field.formControl?.valid || false;
    }

    return field.fieldGroup ? field.fieldGroup.every((f) => this.isValid(f)) : true;
  }

}